export const ICON_FILL_COLOR = '#5c5e5e';
export const ICON_SIZE = 28;
